import axios from "@/index";
const dictionaries = {
  state: {
    dictionariesCategoryList: [],
    dictionariesData: [],
    applicationCategoryCodeMax: [],
    applicationCategoryOptions: []
  },
  getters: {},
  actions: {
    getDictionariesCategoryList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setDictionariesCategoryList",
                (state, { dictionariesCategoryList: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getDictionariesCategoryById: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setDictionariesCategoryById",
                (state, { dictionariesData: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getApplicationCategoryCodeMax: (
      { commit, state, dispatch },
      config = {}
    ) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setApplicationCategoryCodeMax",
                (state, { applicationCategoryCodeMax: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getApplicationCategoryOptions: (
      { commit, state, dispatch },
      config = {}
    ) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setApplicationCategoryOptions",
                (state, { applicationCategoryOptions: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mutations: {
    setDictionariesCategoryList(state, action) {
      state.dictionariesCategoryList = action.dictionariesCategoryList;
    },
    setDictionariesCategoryById(state, action) {
      state.dictionariesData = action.dictionariesData;
    },
    setApplicationCategoryCodeMax(state, action) {
      state.applicationCategoryCodeMax = action.applicationCategoryCodeMax;
    },
    setApplicationCategoryOptions(state, action) {
      state.applicationCategoryOptions = action.applicationCategoryOptions;
    }
  }
};
export default dictionaries;
